// nice multiple select

// elements
const event_select = document.getElementById("einsatz_internal");
const eventday_select = document.getElementById("einsatztag_einsatztyp");

if (event_select) {
	NiceSelect.bind(event_select, {showSelectedItems: true, placeholder: 'Bitte wählen', selectedtext: 'ausgewählt'});
}
if (eventday_select) {
	NiceSelect.bind(eventday_select, {showSelectedItems: true, placeholder: 'Bitte wählen', selectedtext: 'ausgewählt'});
}